import DataHelpers from './DataHelpers'
import FirebaseHelpers from './FirebaseHelpers'
import Store from '../store/Store'

export default class ScrollHelpers {
    static officesList() {   
        let offices = []
        let userKey = Store.getters.uid
        if(userKey) {
            const ref = DataHelpers.getRootRef().child('users').child(userKey).child('offices')
            console.log('UserHelpers > officesList > Ref', ref.toString())
            ref.on('value', snap => {
                offices = FirebaseHelpers.snapshotToArray(snap)
            })
        }
        return offices
    }

    static scrollStop (el, callback) {

        // Make sure a valid callback was provided
        if (!callback || typeof callback !== 'function') return;
    
        // Setup scrolling variable
        var isScrolling
    
        // Listen for scroll events
        el.addEventListener('scroll', function (event) {
    
            // Clear our timeout throughout the scroll
            window.clearTimeout(isScrolling)
    
            // Set a timeout to run after scrolling ends
            isScrolling = setTimeout(function() {
    
                // Run the callback
                callback()
    
            }, 700)
    
        }, false)
    
    }

    static isElementInViewport (el) {
        var rect = el.getBoundingClientRect()
    
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        )
    }

    static getFirstVisibleElement(parent, className) {
        let children = parent.getElementsByClassName(className)
        for(let n = 0; n < children.length; n++) {
            let child = children[n]
            if(this.isElementInViewport(child)) {
                return child
            }
        }
        return null
    }


}


// WEBPACK FOOTER //
// ./src/helpers/ScrollHelpers.js